/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */



import React, {useEffect, useState} from "react";
import {Badge, Button, Card, Col, Form, Input, message, notification, Result, Row, Space} from 'antd';
import {UserOutlined} from "@ant-design/icons";
import {IfTruthy} from "../../component/if.equal.component";
import UserService from "../../service/user.service";

let userSVC = new UserService()

export const ForgotPasswordPage = (props: any)=>{
    const [email, setEmail] = useState(props?.history?.location?.state?.email || '')
    const [emailSent, setEmailSent] = useState(false)

    const sendEmail = (v: any)=>{
        setEmailSent(true)
        userSVC.forgot(v["m"]).then(()=>{

        }).catch(()=>{
            setEmailSent(false)
            notification.error({
                placement: 'topLeft',
                message: "something went wrong"
            })
        })
    }


    return (
        <Row>
            <Col xs={{span: 24}} lg={{span: 12, offset: 6}}>
                <Badge.Ribbon placement={'start'} text="Forgot Password">
                    <Card style={{paddingTop:40}} >
                        <IfTruthy val={emailSent}>
                            <Result
                                title="Check your email"
                            />
                        </IfTruthy>
                        <IfTruthy val={!emailSent}>
                            <Form
                                size={'large'}
                                name="forgot"
                                className="forgot-form"
                                initialValues={{ m: email }}
                                onFinish={sendEmail}
                            >
                                <Form.Item
                                    name="m"
                                    rules={[{ required: true, message: 'Email required' }]}
                                >
                                    <Input prefix={<UserOutlined className="site-form-item-icon" />}
                                           placeholder="Email"
                                           onChange={(v)=>setEmail(v.target.value)}
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <Space>
                                        <Button type="primary"  htmlType="submit" className="login-form-button">
                                            Reset Password
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Form>
                        </IfTruthy>

                    </Card>
                </Badge.Ribbon>
            </Col>
        </Row>
    )
}
